module.exports = __webpack_public_path__ + "static/media/rise-higher.c4b3e4b4.jpg";